import { Icon } from "@silversea-ssc/ui-components-react";
import { SearchBox } from "react-instantsearch";
import styles from "./SearchInput.module.scss";
import clsx from "clsx";

type Props = {
  className?: string;
  dark?: boolean;
};

const SearchInput: React.FC<Props> = ({ className, dark = false }) => {
  return (
    <SearchBox
      classNames={{
        root: clsx(className, { [styles.dark]: dark }),
        form: styles.searchBox,
        input: styles.input,
        submit: styles.actionButton,
        loadingIndicator: styles.loading,
        reset: styles.reset
      }}
      submitIconComponent={() => (
        <Icon name="search" size="1.5x" padding={false} />
      )}
      resetIconComponent={() => (
        <Icon name="close" size="1.5x" padding={false} />
      )}
      loadingIconComponent={() => null}
      placeholder="Search..."
    />
  );
};

export default SearchInput;
